import { CtrlSelection } from "../TableStore";

export const manualRowSelection = <T extends {}>(
  store: CtrlSelection<T>,
  row: T,
): boolean => {
  const {
    rowKey,
    selectionSettings: { selectionType },
  } = store;
  const existed = store.selected.find((r) => r[rowKey] === row[rowKey]);
  if (selectionType === "checkbox") {
    if (existed) {
      store.safeSelect(store.selected.filter((r) => r[rowKey] !== row[rowKey]));
      return false;
    }
    store.safeSelect([...store.selected, row]);
    return true;
  }
  if (selectionType === "radio") {
    if (existed) {
      store.safeSelect([]);
      return false;
    }
    store.safeSelect([row]);
    return true;
  }
  return false;
};
